import { PriceElementSettings } from 'client/components/core/Sidebar/components/Settings/entities/price-element-settings'
import createCommonEntitySettings from 'client/pages/createCommonEntitySettings'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import { PriceElementInterface } from 'common/types/entities/price-element-interface'
import React from 'react'

const createSettingsForWebsitePricing = (entity: EntityInterface) => {
  switch (entity.type) {
    case EntityTypeEnum.PriceElement:
      return <PriceElementSettings entity={entity as PriceElementInterface} />

    default:
      return createCommonEntitySettings(entity)
  }
}

export default createSettingsForWebsitePricing
